import type { z } from 'zod';
import { AppError } from './errors';
import { supabase } from './supabase';

/**
 * Typed RPC call. The response is validated with Zod so a schema drift
 * surfaces as an error state instead of a broken screen.
 */
export async function rpc<S extends z.ZodType>(fn: string, args: Record<string, unknown>, schema: S): Promise<z.output<S>> {
  let res;
  try {
    res = await supabase.rpc(fn, args);
  } catch {
    throw new AppError('network');
  }
  if (res.error) {
    const msg = res.error.message ?? '';
    // Machine codes are raised as MESSAGE; transport failures come back as TypeError text.
    const code = /^[a-z_]+$/.test(msg) ? msg : res.error.code === '42501' ? 'forbidden' : 'network';
    throw new AppError(code, res.error.details ?? undefined);
  }
  const parsed = schema.safeParse(res.data);
  if (!parsed.success) {
    console.error(`[rpc:${fn}] unexpected response`, parsed.error.issues);
    throw new AppError('bad_response');
  }
  return parsed.data;
}
